import styled from 'styled-components'

const TextWithFileStyle = styled.div`
	--textWithFileWidth: 50%;
	--textWithFileDistance: var(--sp6x);
	--textWithFileHeight: 105.6%;
	--textAddWrapWidth: 65.6%;

	margin-top: var(--bannerDistance);

	.textWithFileWrap {
		display: flex;
		flex-wrap: wrap;
		margin-left: calc(-1 * calc(var(--textWithFileDistance) / 2));
		margin-right: calc(-1 * calc(var(--textWithFileDistance) / 2));

		.col-50 {
			width: var(--textWithFileWidth);
			padding: 0 calc(var(--textWithFileDistance) / 2);

			.imageCont,
			.videoCont {
				--proportion: var(--textWithFileHeight);
				width: 100%;
			}
		}

		.textAddWrap {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.comp-title {
				width: var(--textAddWrapWidth);
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeL}) {
		--textWithFileDistance: var(--sp5x);
		--textWithFileHeight: 105.3%;
		--textAddWrapWidth: 65.6%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeM}) {
		--textWithFileDistance: var(--sp4x);
		--textWithFileHeight: 108.2%;
		--textAddWrapWidth: 66.1%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeS}) {
		--textWithFileDistance: var(--sp4x);
		--textWithFileHeight: 108.7%;
		--textAddWrapWidth: 65.5%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeXS}) {
		--textWithFileDistance: var(--sp3x);
		--textWithFileHeight: 108%;
		--textAddWrapWidth: 48%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}) {
		--textWithFileDistance: var(--sp3x);
		--textWithFileHeight: 108.4%;
		--textAddWrapWidth: 89.4%;

		.textWithFileWrap {
			.textAddWrap {
				align-items: flex-start;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSizeS}) {
		--textWithFileDistance: var(--sp3x);
		--textWithFileHeight: 107.7%;
		--textAddWrapWidth: 100%;

		.textWithFileWrap {
			.textAddWrap {
				align-items: flex-start;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--textWithFileWidth: 100%;
		--textWithFileDistance: var(--sp4x);
		--textWithFileHeight: 82%;
		--textAddWrapWidth: 100%;

		.textWithFileWrap {
			margin-top: var(--sp8x);

			.col-50 {
				&:nth-child(2) {
					margin-top: var(--textWithFileDistance);
				}
			}
		}
	}
`

export default TextWithFileStyle
